import * as React from "react";
import { ButtonInput, Value, Option } from "./ButtonInput";

export type ButtonRadioInputProps = {
  onChange: (selectedValue: unknown | undefined) => void;
  onBlur: (...args: unknown[]) => void;
  value: Value;
  options: Array<Option>;
  textCenter?: boolean;
  fullWidthForDescription?: boolean;
  defaultValue?: string;
};

export const ButtonRadioInput = ({
  onChange,
  onBlur,
  value,
  options,
  textCenter = false,
  fullWidthForDescription = true,
  defaultValue,
  ...restProps
}: ButtonRadioInputProps) => {
  React.useEffect(() => {
    if (defaultValue != null) {
      const convertedDefault =
        defaultValue === "False"
          ? false
          : defaultValue === "True"
          ? true
          : defaultValue;
      onChange(convertedDefault);
    }
  }, []);

  // I have zero idea why it comes back as string
  const convertedValue = value === "False" ? false : value === "True" ? true : value;

  return (
    <ButtonInput
      mode="radio"
      options={options}
      value={[convertedValue]}
      textCenter={textCenter}
      fullWidthForDescription={fullWidthForDescription}
      onChange={(values: Array<Value>) => {
        onChange(values.length ? values[0] : undefined);
      }}
      onBlur={onBlur}
      {...restProps}
    />
  );
};
